import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const MenuQuoteCtas = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section data-testid="menu-quote-ctas" className="tiled relative py-6 md:py-10 bg-[--bg]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <motion.button
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            data-testid="gallery-view-menus-btn"
            onClick={() => navigate("/menus")}
            className="group bg-[--surface] border border-white/10 rounded-2xl p-8 md:p-10 flex items-center justify-between gap-6 text-left hover:border-[--gold] transition-colors duration-400"
          >
            <div>
              <p className="font-mono uppercase tracking-[0.25em] text-[10px] text-[--gold] mb-3">{t("gallery.cta1k")}</p>
              <p className="font-display text-2xl md:text-3xl text-[--text]">{t("gallery.cta1")}</p>
            </div>
            <span className="shrink-0 w-12 h-12 rounded-full border border-[--gold]/60 text-[--gold] flex items-center justify-center group-hover:bg-[--gold] group-hover:text-[#14180E] transition-colors duration-400">
              <ArrowRight size={18} strokeWidth={1.5} />
            </span>
          </motion.button>

          <motion.button
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            data-testid="gallery-quote-btn"
            onClick={() => navigate("/request-a-quote")}
            className="group bg-[--surface] border border-white/10 rounded-2xl p-8 md:p-10 flex items-center justify-between gap-6 text-left hover:border-[--gold] transition-colors duration-400"
          >
            <div>
              <p className="font-mono uppercase tracking-[0.25em] text-[10px] text-[--gold] mb-3">{t("gallery.cta2k")}</p>
              <p className="font-display text-2xl md:text-3xl text-[--text]">{t("gallery.cta2")}</p>
            </div>
            <span className="shrink-0 w-12 h-12 rounded-full border border-[--gold]/60 text-[--gold] flex items-center justify-center group-hover:bg-[--gold] group-hover:text-[#14180E] transition-colors duration-400">
              <ArrowRight size={18} strokeWidth={1.5} />
            </span>
          </motion.button>
          <motion.button
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            data-testid="ctas-gallery-btn"
            onClick={() => navigate("/gallery")}
            className="group md:col-span-2 bg-[--surface] border border-white/10 rounded-2xl p-8 md:p-10 flex items-center justify-between gap-6 text-left hover:border-[--gold] transition-colors duration-400"
          >
            <div>
              <p className="font-mono uppercase tracking-[0.25em] text-[10px] text-[--gold] mb-3">{t("gallery.cta3k")}</p>
              <p className="font-display text-2xl md:text-3xl text-[--text]">{t("gallery.cta3")}</p>
            </div>
            <span className="shrink-0 w-12 h-12 rounded-full border border-[--gold]/60 text-[--gold] flex items-center justify-center group-hover:bg-[--gold] group-hover:text-[#14180E] transition-colors duration-400">
              <ArrowRight size={18} strokeWidth={1.5} />
            </span>
          </motion.button>
        </div>
      </div>
    </section>
  );
};
